import { useToast } from "@chakra-ui/react";

const useToastNotification = () => {
  const toast = useToast();

  const showToast = (
    title: string,
    description: string,
    status: "error" | "warning" | "success",
  ) => {
    toast({
      title,
      description,
      status,
      duration: 3000,
      isClosable: true,
      position: "top",
      variant: ["warning", "success"].includes(status) ? status : undefined,
    });
  };

  return showToast;
};

export default useToastNotification;
